import { BrowserRouter, Routes, Route } from "react-router-dom";

import Landing from "./pages/Landing";
import ProposalViewer from "./pages/ProposalViewer";

import DevPlan from "./pages/DevPlan";
import { AppProvider } from "./context/AppContext";
import AnalyticsListener from "./components/AnalyticsListener";
import ButtonTapSlackNotifier from "./components/ButtonTapSlackNotifier";
import ErrorSlackNotifier from "./components/ErrorSlackNotifier";
import ConsentBanner from "./components/ConsentBanner";


export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AnalyticsListener />
        <ButtonTapSlackNotifier />
        <ErrorSlackNotifier />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/p/:proposalId" element={<ProposalViewer />} />
          <Route path="/dev-plan/:proposalId" element={<DevPlan />} />
        </Routes>
        <ConsentBanner />
      </BrowserRouter>
    </AppProvider>
  );
}
